import {Injectable} from '@angular/core';
import {ApiService} from './api.service';

@Injectable()
export class MembershipService {

    constructor(private api: ApiService) {
    }

    getUserDocuments(id: any , query?: any) {
        return this.api.get(this.api.path + '/documents/', {...query, ...{userId: id}});
    }
    getUserImages(id:any) {
        return this.api.get(this.api.path + '/single-user-images/' + id);
    }
    documentReject(id: number, query: any){
        return this.api.post(this.api.path + '/documentReject/' + id, query);
    }
    documentAccept(id: number, query: any){
        // console.log(id, query); 
        return this.api.post(this.api.path + '/documentAccept/' + id, query);
    }
    // docAccpet
    getMembers(query?: any) {
        return this.api.get(this.api.path + '/membership', query);
    }
   getVipLevels(query?: any) {
        return this.api.get(this.api.path + "/get/all/levels", query);
    }
    insert(data: any) {
        return this.api.post(this.api.path + '/membership', data);
    }

    update(id: any, data: any) {
        return this.api.post(this.api.path + '/membership/' + id, data);
    }

    delete(id: any) {
        return this.api.delete(this.api.path + '/membership/' + id);
    }

    getMemberOverview(id: number) {
        return this.api.get(this.api.path + '/membership/' + id + '/overview');
    }

    getLastActivities(id: number) {
        return this.api.get(this.api.path + '/membership/' + id + '/last-activities');
    }

    getMemberWallet(id: number) {
        return this.api.get(this.api.path + '/membership/' + id + '/wallet');
    }

    getMember(id: number) {
        return this.api.get(this.api.path + '/membership/' + id);
    }

    forgetPassword(id: number) {
        return this.api.post(this.api.path + '/membership/' + id + '/forget');
    }

    resetGoogleAuth(id: number) {
        return this.api.post(this.api.path + '/membership/' + id + '/reset');
    }

    getWithdrawalAmount(id: number) {
        return this.api.get(this.api.path + '/membership/' + id + '/isWithdrawal');
    }

    blockWallet(id: number, data: any) {
        return this.api.post(this.api.path + '/membership/' + id + '/walletBlocked', data);
    }

    updateWallet(id: any, data: any) {
        return this.api.post(this.api.path + '/membership/' + id + '/wallet', data);
    }

    previewResellerChange(id: number, resellerId: number) {
        return this.api.get(this.api.path + '/membership/' + id + '/reseller/preview', {resellerId});
    }

    changeReseller(id: number, resellerId: number) {
        return this.api.post(this.api.path + '/membership/' + id + '/reseller', {resellerId});
    }

    getMemberTransactions(id: number, query?: any) {
        return this.api.get(this.api.path + '/transaction/', {...query, ...{userId: id}});
    }

    getMemberCoupons(id: number, query?: any) {
        return this.api.get(this.api.path + '/coupon/', {...query, ...{userId: id}});
    }

    getMemberBonusRules(id: number, query?: any) {
        return this.api.get(this.api.path + '/membership/' + id + '/bonus', query);
    }

    addBonus(id: number, data: any) {
        return this.api.post(this.api.path + '/membership/' + id + '/bonus', data);
    }

    getMemberNotes(id: number, query?: any) {
        return this.api.get(this.api.path + '/membership/' + id + '/notes', query);
    }

    insertMemberNote(id: number, data: any) {
        return this.api.post(this.api.path + '/membership/' + id + '/notes', data);
    }

    updateMemberNote(id: number, noteId: number, data: any) {
        return this.api.post(this.api.path + '/membership/' + id + '/notes/' + noteId, data);
    }

    deleteMemberNote(id: number, noteId: number) {
        return this.api.delete(this.api.path + '/membership/' + id + '/notes/' + noteId);
    }

    getMemberLimits(id: number, query?: any) {
        return this.api.get(this.api.path + '/membership/' + id + '/limit', query);
    }

    getMemberAccessLogs(id: number, query?: any) {
        return this.api.get(this.api.path + '/membership/' + id + '/access', query);
    }

    getMemberRelatedAccess(id: number, type: string, query?: any) {
        return this.api.get(this.api.path + '/membership/' + id + '/access/related/' + type, query);
    }

    removeMemberSession(id: any) {
        return this.api.delete(this.api.path + '/membership/' + id + '/online');
    }

    addMember(data: any) {
        return this.api.post(this.api.path + '/membership', data);
    }

    getUserOptions(query?: any) {
        return this.api.get(this.api.path + '/membership/option', query);
    }

    updateUserOption(id: any, userId: any, formData: any) {
        return this.api.post(this.api.path + '/membership/' + userId + '/option/' + id, formData);
    }
    getAllMembers(query?: any) {
        return this.api.get(this.api.path + '/membership/all');
    }

    /* reseller overview user data */
    getAllResellerUsers(query?: any) {
        return this.api.get(this.api.path + '/membership/resellerUsers');
    }
    /*  */

    getMembershipCount(startDate: string, endDate: string) {
        return this.api.get(this.api.path + '/membership/count', { startDate, endDate });
    }

}
